// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"7398bfc8","283":"c35b04c0","285":"b6710666","329":"707a191b","419":"7867e3b5","550":"93700f50","749":"67270f09","773":"17712d84"}[chunkId] + ".chunk.js";
};